import request from "@/utils/request";

export default {
    fpaList: (param) => {
        return request({
            url: `/fpaPermanent/fpaList`,
            method: "post",
            data: param,
        });
    },

    findCategory: (data, isLogistics) => {
        return request({
            url: `/fpaPermanent/findCategory?isLogistics=${isLogistics}`,
            method: "post",
            data: data,
        });
    },

    fpaDelete: (param) => {
        return request({
            url: `/fpaPermanent/fpaDelete`,
            method: "post",
            data: param,
        });
    },
    fpaWithdraw: (param) => {
        return request({
            url: `/fpaPermanent/withdraw`,
            method: "post",
            data: param,
        });
    },

    fpaListDownload: (param) => {
        return request({
            url: `/fpaPermanent/fpaListDownload`,
            fullResponse: true,
            responseType: "blob",
            method: "post",
            data: param,
        });
    },

    fpaDetail: (ttFpaId) => {
        return request({
            url: `/fpaPermanent/fpaDetail?ttFpaId=` + ttFpaId,
            method: "get",
            data: ttFpaId,
        });
    },
    getDcCurrentAdp: (dcId) => {
        return request({
            url: `/dc/dcCurrentAdp?dcId=${dcId}`,
            method: "get",
            data: dcId,
        });
    },
    plantSearch: (param) => {
        return request({
            url: "/supplier/listPlantOfGroup",
            method: "post",
            data: param,
        });
    },

    fpaSave: (param) => {
        return request({
            url: "/fpaPermanent/fpaSave",
            method: "post",
            data: param,
        });
    },
    fpaCheckType: (param) => {
        return request({
            url: "/fpaPermanent/transportationMethodValidate",
            method: "post",
            data: param,
        });
    },
    ssApproving: (param) => {
        return request({
            url: "/fpaPermanent/ssApproving",
            method: "post",
            data: param,
        });
    },
    lmApproving: (param) => {
        return request({
            url: "/fpaPermanent/lmApproving",
            method: "post",
            data: param,
        });
    },
    lmReApproving: (param) => {
        return request({
            url: "/fpaPermanent/lmReApproving",
            method: "post",
            data: param,
        });
    },
    lmDirectorApproving: (param) => {
        return request({
            url: "/fpaPermanent/lmDirectorApproving",
            method: "post",
            data: param,
        });
    },
    audit: (param) => {
        return request({
            url: "/fpaPermanent/audit",
            method: "post",
            data: param,
        });
    },
    ssReApproving: (param) => {
        return request({
            url: "/fpaPermanent/ssReApproving",
            method: "post",
            data: param,
        });
    },
    ssDirectorApproving: (param) => {
        return request({
            url: "/fpaPermanent/ssDirectorApproving",
            method: "post",
            data: param,
        });
    },
    fdApproving: (param) => {
        return request({
            url: "/fpaPermanent/fdApproving",
            method: "post",
            data: param,
        });
    },
    snrDirectorApproving: (param) => {
        return request({
            url: "/fpaPermanent/snrDirectorApproving",
            method: "post",
            data: param,
        });
    },
    scmVpApproving: (param) => {
        return request({
            url: "/fpaPermanent/scmVpApproving",
            method: "post",
            data: param,
        });
    },
    cfoApproving: (param) => {
        return request({
            url: "/fpaPermanent/cfoApproving",
            method: "post",
            data: param,
        });
    },
    ceoApproving: (param) => {
        return request({
            url: "/fpaPermanent/ceoApproving",
            method: "post",
            data: param,
        });
    },
    hgsApproving: (param) => {
        return request({
            url: "/fpaPermanent/suPreAudit",
            method: "post",
            data: param,
        });
    },
    scFinanceApproving: (param) => {
        return request({
            url: "/fpaPermanent/scFinanceApproving",
            method: "post",
            data: param,
        });
    },
    suSignSubmit: (param) => {
        return request({
            url: "/fpaPermanent/suSignSubmit",
            method: "post",
            data: param,
        });
    },
    returnToSu: (param) => {
        return request({
            url: "/fpaPermanent/returnToSu",
            method: "post",
            data: param,
        });
    },
    fpaMaterialSearch: (eightBitCode) => {
        return request({
            url: `/fpaPermanent/fpaMaterialSearch?eightBitCode=` + eightBitCode,
            method: "get",
            data: eightBitCode,
        });
    },

    fpaPermanentReport: (param) => {
        return request({
            url: `/fpaReport/permanentReport`,
            method: "post",
            data: param,
        });
    },

    fpaPermanentReportCount: () => {
        return request({
            url: `/fpaReport/permanentReportCount`,
            method: "get",
        });
    },

    fpaReportDownload: (param) => {
        return request({
            url: `/fpaReport/permanentDownload`,
            fullResponse: true,
            responseType: "blob",
            method: "post",
            data: param,
        });
    },

    fpaMaterialReport: (param) => {
        return request({
            url: `/fpaReport/materialReport`,
            method: "post",
            data: param,
        });
    },

    fpaMaterialReportCount: () => {
        return request({
            url: `/fpaReport/materialReportCount`,
            method: "get",
        });
    },

    fpaMaterialReportDownload: (param) => {
        return request({
            url: `/fpaReport/materialDownload`,
            fullResponse: true,
            responseType: "blob",
            method: "post",
            data: param,
        });
    },

    fpaPdfDownload: (ttFpaId) => {
        return request({
            url: `/fpaPermanent/fpaPdfDownload?ttFpaId=` + ttFpaId,
            fullResponse: true,
            responseType: "blob",
            method: "get",
            data: ttFpaId,
        });
    },

    getCurrentDirectFreight: (eightBitCode) => {
        return request({
            url: `/fpaPermanent/getCurrentDirectFreight`,
            method: "post",
            data: eightBitCode,
        });
    },
    getFindLogisticManager: () => {
        return request({
            url: `/fpaPermanent/findLogisticManager`,
            method: "get",
        });
    },

    getLogisticsType: (category2) => {
        return request({
            url: `/fpaPermanent/isLogisticsType?category=${category2}`,
            method: "get",
        });
    },

    getAgreedSupplyTemplate: (param) => {
        return request({
            url: `/file/downloadTemplate`,
            method: "post",
            data: param,
            responseType: "blob"
        })
    }
};